import { Component, OnInit, Input, Output, OnChanges, SimpleChanges, EventEmitter } from '@angular/core';
import { MapService } from '../../../services/map/map.service';
import { TranslateService } from '@ngx-translate/core';
import * as ol from 'openlayers';

@Component({
    selector: 'app-measure-surface-control',
    templateUrl: './measure-surface-control.component.html',
    styleUrls: ['./measure-surface-control.component.css']
})
export class MeasureSurfaceControlComponent implements OnInit, OnChanges {
    /* Events Emitter's */
    @Output() private addInteraction = new EventEmitter<any>();
    @Output() private addLayerTool = new EventEmitter<any>();
    @Output() private removeInteraction = new EventEmitter<any>();

    @Input() activateInteraction: boolean;

    public sketch = {};
    public wgs84Sphere = new ol.Sphere(6378137);
    private sourceFeaturesLayer: ol.source.Vector;
    private mesurarFeaturesLayer: ol.layer.Vector = null;
    private drawInteraction;
    private onDrawStartMap: any;
    private onChangeMap: any;
    private onDrawEndMap: any;
    private perimeter = "0 m";
    private surface = "Àrea: 0 m<sup>2</sup>";
    constructor(private mapService: MapService, private translateService: TranslateService) {
    }

    ngOnInit() {

    }

    ngOnChanges(changes: SimpleChanges) {
        try {

            if (typeof (changes.activateInteraction) !== "undefined" && changes.activateInteraction) {
                this.createLayer();
                this.addInteractionHandler();
            }
        }
        catch (e) { }
    }
    private createLayer() {
        this.mesurarFeaturesLayer = new ol.layer.Vector({
            source: new ol.source.Vector(),
            style: [new ol.style.Style({
                stroke: new ol.style.Stroke({
                    color: 'rgb(0,128,255)',
                    width: 8
                }),
                fill: new ol.style.Fill({
                    color: 'rgba(255,255,255,0.5)'
                })
            }), new ol.style.Style({
                stroke: new ol.style.Stroke({
                    color: 'rgb(124,214,253)',
                    width: 5
                })
            })]
        });

        let properties = {
            id: "olMeasureSurface",
            name: "olMeasureSurface",
            zIndex: 1000,
            isTool: true
        };

        this.mesurarFeaturesLayer.setProperties(properties, true);

        this.addLayerTool.emit(this.mesurarFeaturesLayer)
    }

    private removeInteractionHandler(): void {
        this.removeInteraction.emit({ closePanel: true, interaction: this.drawInteraction });
    }

    private addInteractionHandler(): void {
        let listener;



        this.drawInteraction = new ol.interaction.Draw({
            source: this.mesurarFeaturesLayer.getSource(),
            type: "Polygon",
            style: new ol.style.Style({
                fill: new ol.style.Fill({
                    color: 'rgba(255, 255, 255, 0.2)'
                }),
                stroke: new ol.style.Stroke({
                    color: '#ffcc33',
                    width: 5
                }),
                image: new ol.style.Circle({
                    radius: 7,
                    fill: new ol.style.Fill({
                        color: '#ffcc33'
                    })
                })
            })
        });
        this.drawInteraction.setProperties({ idInteraction: "olMeasureSurface" });
        this.addInteraction.emit(this.drawInteraction);

        this.onChangeMap = (event) => {

            var geom = event.target;

            this.perimeter = this.formatLength(geom);
            this.surface = this.formatArea(geom);

        }

        this.onDrawStartMap = (event) => {
            var sketch = event;
            this.mesurarFeaturesLayer.getSource().clear();
            this.mesurarFeaturesLayer.getSource().once('addfeature', this.onDrawEndMap);
            listener = sketch.feature.getGeometry().on('change', this.onChangeMap);
        };

        this.drawInteraction.on('drawstart', this.onDrawStartMap);

        this.onDrawEndMap = (event) => {
            // unset tooltip so that a new one can be created
            console.log("measure feature >>>>", this.mesurarFeaturesLayer.getSource().getFeatures().length);
            //ol.Observable.unByKey(listener);
            console.log("measure feature >>>>", this.mesurarFeaturesLayer.getSource().getFeatures().length);

        }


        // this.draw.on('drawend', this.onDrawEndMap);

    }

    /**
     * Format length output.
     * @param {ol.geom.LineString} line The line.
     * @return {string} The formatted length.
     */
    private formatLength(geom: ol.geom.Geometry): string {
        try {
            var length = 0;
            if (geom instanceof ol.geom.Polygon) {
                var coordinatesGeom = geom.getLinearRings()[0];
                var linestring = new ol.geom.LineString(coordinatesGeom.getCoordinates());
                var coordinates = linestring.getCoordinates();
                var sourceProj = this.mapService.getConfigurationSaved()["mapconfig"].srs;
                for (var i = 0, ii = coordinates.length - 1; i < ii; ++i) {
                    var c1 = ol.proj.transform(coordinates[i], sourceProj, 'EPSG:4326');
                    var c2 = ol.proj.transform(coordinates[i + 1], sourceProj, 'EPSG:4326');
                    length += this.wgs84Sphere.haversineDistance(c1, c2);
                }

                var output;
                if (length > 100) {
                    output = (Math.round(length / 1000 * 1000) / 1000) +
                        ' ' + 'km';
                } else {
                    output = (Math.round(length * 100) / 100) +
                        ' ' + 'm';
                }
            } else if (geom instanceof ol.geom.LineString) {
                var coordinates = geom.getCoordinates();
                length = 0;
                var sourceProj = this.mapService.getConfigurationSaved()["mapconfig"].srs;
                for (var i = 0, ii = coordinates.length - 1; i < ii; ++i) {
                    var c1 = ol.proj.transform(coordinates[i], sourceProj, 'EPSG:4326');
                    var c2 = ol.proj.transform(coordinates[i + 1], sourceProj, 'EPSG:4326');
                    length += this.wgs84Sphere.haversineDistance(c1, c2);
                }

                var output;
                if (length > 100) {
                    output = (Math.round(length / 1000 * 1000) / 1000) +
                        ' ' + 'km';
                } else {
                    output = (Math.round(length * 100) / 100) +
                        ' ' + 'm';
                }
            }

        } catch (e) {

        }
        return output;
    };

    private formatArea(poligon: ol.geom.Polygon) {
        var output = "0";
        let area_traduida;
        try {
            var area = poligon.getArea();
            this.translateService.get('Àrea').subscribe((traduccio_realitzada_titol: string) => {
                area_traduida = traduccio_realitzada_titol
            });
            if (area > 10000) {
                output = (Math.round(area / 1000000 * 1000) / 1000) +
                    ' ' + 'km<sup>2</sup>';
            } else {
                output = (Math.round(area * 1000) / 1000) +
                    ' ' + 'm<sup>2</sup>';
            }

        }
        catch (e) {
            output += 'm<sup>2</sup>';
        }
        return area_traduida + output;
    }

}



// WEBPACK FOOTER //
// /usr/nexus/jenkins/workspace/enmapa-geoportal-frontend/src/app/components/tools/measure-surface-control/measure-surface-control.component.ts